import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { InlineMath } from 'react-katex'
import styled, { css } from 'styled-components'

import { RichTextRenderProps } from './types'

import 'katex/dist/katex.min.css'

/**
 * 富文本渲染组件
 *
 * @param param - 参数
 * @param param.value - 富文本内容
 * @param param.largeFontSize - 大字体显示（用户前台首页使用）
 * @returns 富文本渲染组件
 */
export const RichTextRenderer: React.FC<RichTextRenderProps> = ({
  value,
  style,
  largeFontSize,
}) => {
  const editorContentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const view = editorContentRef.current
    if (!view) return
    view.innerHTML = value
    const formulaEles = view.querySelectorAll('[data-w-e-type="formula"]')
    formulaEles.forEach((f) => {
      const v = f.getAttribute('data-value') || ''
      ReactDOM.render(<InlineMath math={v} />, f)
    })
  }, [value])

  return (
    <Renderer
      ref={editorContentRef}
      style={style}
      className="editor-content-view"
      $largeFontSize={!!largeFontSize}
    />
  )
}

const Renderer = styled.div<{ $largeFontSize: boolean }>`
  max-width: 100%;
  color: ${(props) =>
    props.$largeFontSize ? props.theme.text._1 : props.theme.text._2};
  p {
    ${(props) =>
      props.$largeFontSize
        ? css`
            line-height: 28px;
            margin: 8px 0;
            font-size: 16px;
            & > span {
              font-size: 16px !important;
            }
          `
        : css`
            line-height: 22px;
            margin: 3px;
            font-size: 14px;
            & > span {
              font-size: 14px !important;
            }
          `}
  }
  li {
    ${(props) =>
      props.$largeFontSize
        ? css`
            line-height: 28px;
            font-size: 16px;
          `
        : css`
            line-height: 22px;
            font-size: 14px;
          `}
  }
  img {
    max-width: 100%;
  }
  video {
    max-width: 100%;
    background-color: ${(props) => props.theme.background._4};
  }
  div[data-w-e-type='video'],
  video {
    max-width: 100%;
    max-height: 100%;
  }
  span[data-w-e-type='formula'] {
    margin: 0 3px;
    padding: 3px 3px;
  }
  table {
    min-width: 100%;
    border-collapse: collapse;
    word-break: break-all;
    word-wrap: break-word;
  }
`
